import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7668812d"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7668812d')) {
      api.createRecord('7668812d', component.options)
    } else {
      api.reload('7668812d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7668812d", function () {
      api.rerender('7668812d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/card/index.vue"
export default component.exports